import './index.scss';
import {cloneElement, FunctionComponent, PropsWithChildren, ReactElement, ReactNode, useMemo} from "react";
import {ToastContentProps as ToastifyToastContentProps} from "react-toastify/dist/types";
import {SvgIconOwnProps} from "@mui/material/SvgIcon/SvgIcon";
import {Typography} from "@mui/material";
import ToastContentCloseButton from "./close-button";
import classNames from 'classnames';

export interface ToastContentProps {
    title?: string,
    message?: string,
    icon?: ReactElement,
    className?: string,
    closeButton?: boolean,
    actions?: ReactNode,
    toastProps: ToastifyToastContentProps['toastProps'],
    useChildren?: boolean,
}

const ToastContent: FunctionComponent<PropsWithChildren<ToastContentProps>> = (props) => {
    const includeCloseButton = useMemo(() => props.closeButton !== false, [props.closeButton])

    return (
        <>
            <div className={'toast-content-container'}>
                <div className={'toast-content-header'}>
                    {
                        props.icon &&
                        cloneElement(props.icon, {sx: {marginInlineEnd: 1, width: 24, height: 24}} as SvgIconOwnProps)
                    }
                    <Typography variant={'body2'}>
                        {props?.title ?? ''}
                    </Typography>
                    <ToastContentCloseButton {...props.toastProps} key={props.toastProps.key} includeCloseButton={includeCloseButton}/>
                </div>
                <div className={classNames('toast-content', {'padded': includeCloseButton})}>
                    {
                        !!props.useChildren &&
                        props.children
                    }
                    {
                        !props.useChildren &&
                        <Typography
                            variant={'caption'}
                            component={"div"}
                            dangerouslySetInnerHTML={{__html: props?.message ?? "<p></p>"}}
                        />
                    }
                </div>
                {
                    props.actions &&
                    <div className={'toast-content-actions'}>
                        {props.actions}
                    </div>
                }
            </div>
        </>
    )

}

export * from './types';
export default ToastContent;
